<button [type]="actionType()" [tabIndex]="-1">
  <div class="icon">
    <onyx-icon name="clear-outlined" [size]="20"></onyx-icon>
  </div>
</button>
